module.exports = __webpack_public_path__ + "static/media/014.5245e45d.jpg";